<template>
  <Menu />
  <section id="politicaDePrivacidad">
    <PoliticaDePrivacidad />
  </section>
  <Footer />
</template>

<script>
import PoliticaDePrivacidad from "@/components/politicaDePrivacidad/PoliticaDePrivacidadPrincipal.vue";
import Menu from "@/components/menu/MenuPrincipal.vue";
import Footer from "@/components/footer/FooterPrincipal.vue";

export default {
  name: "Politica De Privacidad",
  components: {
    PoliticaDePrivacidad,
    Menu,
    Footer,
  },
};
</script>